export default {
  joinMeetingTemp: null
}
